import OAuthLogin from './pages/oauth-login/oauth-login'

export const LOGIN_ROUTE = '/login'
export const USERS_ROUTE = '/users'
export const USER_LIST_ROUTE = '/view-users'
export const CHANGE_LDAP_PASSWORD_ROUTE = '/change-ldap-password/:id'

const routes = [
  {
    path: '/login',
    element: <OAuthLogin />
  }
]

export default routes
